<div
    class="w-full border-b border-primary mb-4 mt-5 pb-2 flex flex-row justify-between items-center"
    [ngClass]="{ 'border-t pt-2': topBorder }"
>
    <h3 class="mb-0">{{ text }}</h3>
    <div class="flex flex-row items-center gap-2">
        <ng-content select="[buttons]"></ng-content>
    </div>
</div>
